import { connect } from 'react-redux'
import * as selector from '../../state/detail/selector'
import TreatmentFeedback from '../detail/TreatmentFeedback'


const mapStateToProps = (state, props) => {
    return {
        customer: selector.selectCustomer(state),
    }
}


export default connect(mapStateToProps)(TreatmentFeedback)



// WEBPACK FOOTER //
// ./src/modules/customer/component/task-widget/TreatmentFeedbackWidgetContainer.js